import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-integrationhome',
    templateUrl: './integrationhome.component.html',
    styleUrls: ['./integrationhome.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntegrationHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
